/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UpdateWarehousePackageCostRequest interface.
 */
export function instanceOfUpdateWarehousePackageCostRequest(value) {
    if (!('warehouseCostUsd' in value) || value['warehouseCostUsd'] === undefined)
        return false;
    return true;
}
export function UpdateWarehousePackageCostRequestFromJSON(json) {
    return UpdateWarehousePackageCostRequestFromJSONTyped(json, false);
}
export function UpdateWarehousePackageCostRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'warehouseCostUsd': json['warehouseCostUsd'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}
export function UpdateWarehousePackageCostRequestToJSON(json) {
    return UpdateWarehousePackageCostRequestToJSONTyped(json, false);
}
export function UpdateWarehousePackageCostRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'warehouseCostUsd': value['warehouseCostUsd'],
        'note': value['note'],
    };
}
